export default __webpack_public_path__ + "static/media/SJA1370.34I-41603_-24882_0.cb170faa.jpg";